// extracted by mini-css-extract-plugin
export var bounce = "_oq-1";
export var generatingText = "_oq-6";
export var lightning = "_oq-4";
export var popup = "_oq-5";
export var progressBar = "_oq-7";
export var progressFill = "_oq-8";
export var progressShimmer = "_oq-9";
export var progressText = "_oq-a";
export var shimmer = "_oq-3";
export var uploadIcon = "_oq-0";
export var uploadingText = "_oq-2";